
define('text!plugins/slug/template.html',[],function () { return '<div class="row">\n    <div class="small-12 columns">\n        <input type="text" data-rv-value="model:value | asSlug">\n    </div>\n</div>';});

